import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import _ from "lodash"
import { IObjectSecurity } from "../../models/data/ObjectDetails"
import MultiUserRoleChips from "./MultiUserRoleChips"

interface IProps {
    objectAuditSecurity: IObjectSecurity
    handleUpdate(objectAuditSecurity: IObjectSecurity): void
}
interface IState {
    openAddSupervisorDialog: boolean
}

export default class ObjectDetailsSecurity extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddSupervisorDialog: false,
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <MultiUserRoleChips
                    selectedRoleIds={this.props.objectAuditSecurity.ViewAccessRoleIdList}
                    label={strings.View + " " + strings.Roles}
                    handleChange={(selectedRoleIds: string[])=> {
                        this.props.objectAuditSecurity.ViewAccessRoleIdList = selectedRoleIds
                        this.props.handleUpdate(this.props.objectAuditSecurity)
                    }}
                    readonly={false}
                    error={null}
                />                                                         
                <MultiUserRoleChips
                    selectedRoleIds={this.props.objectAuditSecurity.CreateAccessRoleIdList}
                    label={strings.Create + " " + strings.Roles}
                    handleChange={(selectedRoleIds: string[])=> {
                        this.props.objectAuditSecurity.CreateAccessRoleIdList = selectedRoleIds
                        this.props.handleUpdate(this.props.objectAuditSecurity)
                    }}
                    readonly={false}
                    error={null}
                />                            
                <MultiUserRoleChips
                    selectedRoleIds={this.props.objectAuditSecurity.WriteAccessRoleIdList}
                    label={strings.Edit + " " + strings.Roles}
                    handleChange={(selectedRoleIds: string[])=> {
                        this.props.objectAuditSecurity.WriteAccessRoleIdList = selectedRoleIds
                        this.props.handleUpdate(this.props.objectAuditSecurity)
                    }}
                    readonly={false}
                    error={null}
                />    

                <MultiUserRoleChips
                    selectedRoleIds={this.props.objectAuditSecurity.DeleteAccessRoleIdList}
                    label={strings.Delete + " " + strings.Roles}
                    handleChange={(selectedRoleIds: string[])=> {
                        this.props.objectAuditSecurity.DeleteAccessRoleIdList = selectedRoleIds
                        this.props.handleUpdate(this.props.objectAuditSecurity)
                    }}
                    readonly={false}
                    error={null}
                />                                                                                   
            </div>

        )
    }
}